import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    fetch: (config: AxiosRequestConfig) => api.get(`/order/locations`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/order/locations/${url.id}`, config),
    modules: {
        fetch: (config: AxiosRequestConfig, url: { locationId: number }) =>
            api.get(`/order/locations/${url.locationId}/modules`, config),
        // get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        //     api.get(`/order/locations/${url.id}/modules/${url.id}`, config),
        datatrans: {
            gateway: (
                config: AxiosRequestConfig,
                url: { locationId: number },
            ) =>
                api.get(
                    `/order/locations/${url.locationId}/modules/Datatrans/gateway`,
                    config,
                ),
        },
        gastroPay: {
            configure: (
                data: object,
                config: AxiosRequestConfig,
                url: { locationId: number },
            ) =>
                api.post(
                    `/order/locations/${url.locationId}/modules/GastroPay`,
                    data,
                    config,
                ),
            gateway: (
                config: AxiosRequestConfig,
                url: { locationId: number },
            ) =>
                api.get(
                    `/order/locations/${url.locationId}/modules/GastroPay/gateway`,
                    config,
                ),
            remove: (config: AxiosRequestConfig, url: { locationId: number }) =>
                api.delete(
                    `/order/locations/${url.locationId}/modules/GastroPay`,
                    config,
                ),
            update: (
                data: object,
                config: AxiosRequestConfig,
                url: { locationId: number },
            ) =>
                api.put(
                    `/order/locations/${url.locationId}/modules/GastroPay`,
                    data,
                    config,
                ),
        },
    },
};

export default requests;
